import { base } from '$app/paths';
import type { MatrixClientConfig } from '$lib/types';
import { CONFIG_FILE } from '$lib/constants';

export class ConfigService {
	/**
	 * Fetches the deployment's client configuration file.
	 * @param fetcher - fetch implementation supplied by the caller
	 * @returns the parsed `config.json`
	 * @throws when the file cannot be fetched or is not valid JSON
	 */
	static async load(fetcher: typeof fetch): Promise<MatrixClientConfig> {
		const response = await fetcher(`${base}/${CONFIG_FILE}`, { method: 'GET' });
		return response.json();
	}
}
